import { USER_ROLES } from '@/shared/types/permissions';

import type { RootState } from '@/store';

import React from 'react';

import { useSelector } from 'react-redux';

import { Navigate } from 'react-router-dom';

export const DefaultRedirect: React.FC = () => {
  const currentUser = useSelector((state: RootState) => state.users.currentUser);
  const isDscManager = currentUser?.roles?.some((role) => role.name === USER_ROLES.DSCManager);

  if (isDscManager) {
    return <Navigate to="/ds-agents" replace />;
  }

  return <Navigate to="/customers" replace />;
};
